import { Fade } from "@progress/kendo-react-animation";
import {
  NotificationGroup,
  Notification,
} from "@progress/kendo-react-notification";
import React, { PropsWithChildren, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Type, useSnackbar } from "@/components/Snackbar/KendoSnackbarProvider";
interface State {
  success: boolean;
  error: boolean;
  warning: boolean;
  info: boolean;
  none: boolean;
}
const Notifications: React.FC<{ message?: string; show?: boolean }> = ({
  message,
  show = true,
}) => {
  const { t } = useTranslation();
  const [state, setState] = React.useState<State>({
    success: show,
    error: false,
    warning: false,
    info: false,
    none: false,
  });
  const { success } = state;
  const displayMessage = message || t("successMessage");
  return (
    <NotificationGroup
      style={{ top: 100, left: "50%", transform: "translateX(-50%)" }}
    >
      <Fade>
        {success && (
          <Notification
            type={{ style: "success", icon: true }}
            closable={true}
            onClose={() => setState({ ...state, success: false })}
          >
            <span>{displayMessage}</span>
          </Notification>
        )}
      </Fade>
    </NotificationGroup>
  );
};

export const InfoNotification: React.FC<{
  message: string;
  show?: boolean;
}> = ({ message, show = true }) => {
  const [state, setState] = React.useState<boolean>(show);

  setTimeout(() => {
    setState(false);
  }, 10000); // 👈️ time in milliseconds

  return (
    <div className="tlx-notification">
      <Fade>
        {state && (
          <Notification
            type={{ style: "info", icon: true }}
            closable={true}
            onClose={() => setState(false)}
          >
            <span>{message}</span>
          </Notification>
        )}
      </Fade>
    </div>
  );
};

/**
 * SuccessNotification component
 * @deprecated use `useSnackbar` hook instead
 */
export const SuccessNotification: React.FC<
  {
    message?: string | null;
    show?: boolean;
    onClose?: () => void;
    style?: Type;
  } & PropsWithChildren
> = ({ message, onClose, show, style = "success", children }) => {
  const { showMessage } = useSnackbar();

  useEffect(() => {
    if (show && message) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      onClose?.();
      showMessage(message, style);
    }
  }, [message, show, onClose, showMessage, style]);

  useEffect(() => {
    if (show && children) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      onClose?.();
      showMessage(children, style);
    }
  }, [children, show, onClose, showMessage, style]);

  return null;
};

export default Notifications;
